import { GET_SIGNED_URL, GET_VEHICLE_VIDEO_LIST } from '@/services/api/trackvideo/video'
import { client } from '@/services/apolloclient'
import store from '../store'
import { Helper } from '@/mixin/helper'
import { SET_VIDEO_STREAM_STATUS, SET_VIDEO_STREAM_STATUS_OFF } from '@/services/api/onlineCommand'

export const state = {
  fleets: [],
  tempVehicleStatuses: {},
  vehicleStatuses: {},
  loadingFleets: true,
  playlist: [],
  maxVideo: 25,
  gridNumber: 9,
  // This state only used in close from grid playlist, if playlist closed from checkbox, this state will be null
  lastClosedPlaylist: null,
  fleetListDisplay: {},
  workerTrackvision: null,
  recordIdActive: null, // Contain playlistId, recordActive must be 1 playlist
  mapFlespiHowenState: [],
  vehicleTypeList: [],
  vgroupsList: [],
}

export const getters = {
  fleetsListFilter: (state) => (search) => {
    if (!search) {
      return state.fleets || []
    }

    return state.fleets.filter(
      (fleet) =>
        fleet.vehicle.licensePlate.toLowerCase().match(search.toLowerCase()) ||
        (fleet.vehicle.driver1
          ? fleet.vehicle.driver1.fullname.toLowerCase().match(search.toLowerCase())
          : null)
    )
  },
  fleetsList: (state) => state.fleets || [],
  vehicleStatusByVehicleId: (state) => (vehicleId) => {
    return state.vehicleStatuses[vehicleId]
  },
  tempVehicleStatusByVehicleId: (state) => (vehicleId) => {
    return state.tempVehicleStatuses[vehicleId]
  },

  flespiHowenVehicleIds: (state) => {
    return state.fleets
      .filter(
        (fleet) => Helper.methods.getDeviceType(fleet.vehicle.device.deviceCode) === 'flespi-howen'
      )
      .map((fleet) => fleet.vehicleId)
  },
}

export const actions = {
  async requestFleets({ commit }, payload) {
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    await client
      .query({
        query: GET_VEHICLE_VIDEO_LIST,
        variables: payload,
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (response.data.vehicleVideoTrackers.isSuccessful) {
          var vehicles = response.data.vehicleVideoTrackers.vehicleVideoTrackers
          vehicles.forEach(function (item) {
            item.checked = false
            item.playlist = []
            item.channel = []
            item.vehicle.device.deviceType = Helper.methods.getDeviceType(
              item.vehicle.device.deviceCode
            )
            if (item.statusText) {
              item.statusText.split(',').forEach((row, index) => {
                item.channel.push({ text: index + 1, value: `${item.vehicleId}:${row}`, play: 0 })
              })
            }

            const trackvisionDemoId = JSON.parse(
              store.state.identity.featureFlag.find(
                (feature) => feature.key == 'vsms2_trackvision_demo_id'
              ).value
            )
            // Check video demo
            if (
              Object.keys(trackvisionDemoId)
                .map((id) => parseInt(id))
                .includes(item.vehicleId) ||
              Object.keys(dataDemoTrackvision)
                .map((id) => parseInt(id))
                .includes(item.vehicleId)
            ) {
              item.calculatedMotionStatus = 'M'
            }
          })

          commit('setFleets', vehicles)
        }
      })
  },

  async requestFleetsV2({ commit, rootGetters }, payload) {
    await client
      .query({
        query: GET_VEHICLE_VIDEO_LIST,
        variables: payload,
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (response.data.vehicleVideoTrackers.isSuccessful) {
          var vehicles = response.data.vehicleVideoTrackers.vehicleVideoTrackers
          vehicles.forEach(function (item) {
            item.checked = false
            item.playlist = []
            // TODO : remove channel
            item.channel = []
            // This variable model used for select options
            item.playlistModel = []
            item.vehicle.device.deviceType = Helper.methods.getDeviceType(
              item.vehicle.device.deviceCode
            )
            if (item.statusText) {
              item.channel.push({
                text: 'all',
                value: 'all',
              })
              item.statusText.split(',').forEach((row, index) => {
                item.channel.push({
                  text: index + 1,
                  value: `${item.vehicleId}:${row}`,
                  play: 0,
                })
              })
            }
            const dataDemoTrackvision = rootGetters['identity/getFeatureFlagValue'](
              'vsms2_trackvision2_stream_demo_id'
            )
            if (
              Object.keys(dataDemoTrackvision)
                .map((id) => parseInt(id))
                .includes(item.vehicleId)
            ) {
              item.calculatedMotionStatus = 'M'
            }
          })

          commit('setFleets', vehicles)
        }
      })
  },

  async setVehicleTypeAndVgroups({ commit, state }) {
    const tempVehicleType = []
    const tempVgroups = []
    state.fleets.forEach((v) => {
      const _vehicleType = v.vehicle.vehicleType
      if (
        !tempVehicleType.some(({ vehicleTypeId }) => vehicleTypeId === _vehicleType.vehicleTypeId)
      ) {
        tempVehicleType.push(_vehicleType)
      }
      const _vgroups = v.vehicle.vehicle2Vgroup
      _vgroups.forEach((vg) => {
        if (!tempVgroups.some(({ vgroupId }) => vgroupId === vg.vgroupId)) {
          tempVgroups.push(vg)
        }
      })
    })

    commit('setVehicleTypeList', tempVehicleType)
    commit('setVgroupsList', tempVgroups)
  },

  // eslint-disable-next-line no-unused-vars
  async setVideoStreamStatus({ commit, dispatch }, payload) {
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    const isVideoDemo = Object.keys(dataDemoTrackvision).includes(payload.vehicleId.toString())

    // handle video demo
    if (isVideoDemo) {
      const _channelSent = payload.playlist.map((data) =>
        payload.vehicle.device.deviceName.includes('JC')
          ? (parseInt(data.split(':')[1]) + 1).toString()
          : data.split(':')[1]
      )
      return { channelSent: _channelSent, channelNotSent: [] }
    }
    let promises = []

    const deviceType = Helper.methods.getDeviceType(payload.vehicle.device.deviceCode)

    const isJc = deviceType === 'jc'

    // Start stream
    const _channels = [] // '1', '2', '3'
    payload.playlist.forEach((row) => {
      const arr = row.split(':')
      _channels.push(isJc ? (parseInt(arr[1]) + 1).toString() : arr[1])
    })

    if (_channels.length) {
      promises.push(
        dispatch('requestOnlineCommandStreamStatus', {
          channels: _channels,
          imei: payload.vehicle.imei,
          status: true,
          streamingEndpoint: payload.streamingEndpoint,
          statsDataV2: {
            inputDataRequest: _channels.map((channel, index) => ({
              channel,
              id: payload.playlistWithUid[index].uid,
            })),
          },
        })
      )
    }

    return await Promise.all(promises).then((response) => {
      const channelSent =
        response[response.length - 1]?.data.setVideoStreamStatus.setVideoStreamStatus.channelSent
      const channelNotSent =
        response[response.length - 1]?.data.setVideoStreamStatus.setVideoStreamStatus.channelNotSent
      return { channelSent, channelNotSent }
    })
  },

  /**
   *
   * @param {*} param0
   * @param {*} newChannel is array of object with interface like { value: '{vehicleId}:{channel}', uid }
   * @returns
   */
  async handlePlayStreaming(
    { dispatch },
    { newChannel, usingWsFlv, streamingEndpoint, dataVehicle: { deviceCode, vehicleId, imei } }
  ) {
    if (newChannel.length === 0) return { channelSent: [], channelNotSent: [] }
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    const isVideoDemo = Object.keys(dataDemoTrackvision).includes(vehicleId.toString())

    const deviceType = Helper.methods.getDeviceType(deviceCode)
    const isJc = deviceType === 'jc'

    // handle video demo
    if (isVideoDemo || usingWsFlv) {
      return {
        channelSent: newChannel.map((item) => {
          const valCh = item.value
          return isJc ? (parseInt(valCh.split(':')[1]) + 1).toString() : valCh.split(':')[1]
        }),
        channelNotSent: [],
      }
    }

    const payloadChannel = newChannel.map((item) => {
      const valCh = item.value
      return {
        channel: isJc ? (parseInt(valCh.split(':')[1]) + 1).toString() : valCh.split(':')[1],
        id: item.uid,
      }
    })
    const response = await dispatch('requestOnlineCommandStreamStatus', {
      channels: payloadChannel.map((item) => item.channel),
      imei: imei,
      status: true,
      streamingEndpoint: streamingEndpoint,
      statsDataV2: {
        inputDataRequest: payloadChannel,
      },
    })
    const channelSent = response?.data.setVideoStreamStatus.setVideoStreamStatus.channelSent
    const channelNotSent = response?.data.setVideoStreamStatus.setVideoStreamStatus.channelNotSent
    return { channelSent, channelNotSent }
  },

  /**
   *
   * @param {*} param0
   * @param {*} playlistIdsRemoved is array of playlist id string like '{vehicleId}:{channel}'
   */
  handleRemovePlaylistVehicle({ state, commit }, { playlistIdsRemoved }) {
    const newPlaylist = state.playlist.filter((item) => {
      return !playlistIdsRemoved.includes(item.id)
    })

    const tempPlaylist = [...newPlaylist]

    commit('setPlaylistVehicle', tempPlaylist)
  },

  /**
   *
   * @param {*} state
   * @param {*} playlistModel is array of object with interface like { value: '{vehicleId}:{channel}', uid }
   */
  async handleAddPlaylistVehicle(
    { dispatch, commit, state },
    {
      vehicleId,
      deviceCode,
      playlistModel,
      licensePlate,
      calculatedMotionStatus,
      imei,
      driver,
      statusText,
      streamingEndpoint,
      usingWsFlv,
    }
  ) {
    const deviceType = Helper.methods.getDeviceType(deviceCode),
      prevPlaylist = [...state.playlist].filter((x) => x.vehicleId != vehicleId),
      isHlsTesting = JSON.parse(
        store.state.identity.featureFlag.find((feature) => feature.key == 'is_hls_testing').value
      )

    const { isDemo } = await dispatch('handleAddPlaylistVideoDemo', {
      deviceType,
      playlistModel,
      vehicleId,
      statusText,
      licensePlate,
      calculatedMotionStatus,
      imei,
      driver,
      streamingEndpoint,
      prevPlaylist,
      deviceCode,
    })
    if (isDemo) return

    let newPlaylist = []
    playlistModel.forEach((item, index) => {
      const [_, channel] = item.value.split(':')
      // TODO : Please update this domain to get correct domain
      const domain = (index % 5) + 1
      newPlaylist.push({
        id: item.value,
        vehicleId: vehicleId,
        channel,
        camera: statusText.split(',').findIndex((x) => x == channel) + 1,
        licensePlate: licensePlate,
        calculatedMotionStatus: calculatedMotionStatus,
        imei: imei,
        driver: driver,
        deviceType,
        uid: item.uid,
        streamingEndpoint,
        src: Helper.methods.getStreamingUrl(
          deviceCode,
          imei,
          channel,
          domain,
          streamingEndpoint,
          isHlsTesting,
          usingWsFlv
        ),
        usingWsFlv,
        deviceCode,
      })
    })

    const allPlaylist = [...prevPlaylist, ...newPlaylist]
    commit('setPlaylistVehicle', allPlaylist)
  },

  /**
   *
   * @param {*}
   * @param {*} playlistModel  is array of object with interface like { value: '{vehicleId}:{channel}', uid }
   * @returns
   */
  handleAddPlaylistVideoDemo(
    { commit, dispatch },
    {
      deviceType,
      playlistModel,
      vehicleId,
      statusText,
      licensePlate,
      calculatedMotionStatus,
      imei,
      driver,
      streamingEndpoint,
      prevPlaylist,
      deviceCode,
    }
  ) {
    const dataDemoTrackvision = JSON.parse(
        store.state.identity.featureFlag.find(
          (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
        ).value
      ),
      isVideoDemo = Object.keys(dataDemoTrackvision).includes(vehicleId.toString()),
      isJc = deviceType === 'jc'

    if (isVideoDemo) {
      const newPlaylist = []
      playlistModel.forEach((row, index) => {
        const [_, channel] = row.value.split(':')
        const ch = isJc ? parseInt(channel) + 1 : parseInt(channel)

        const flagDomain = ((prevPlaylist.length + index) % 4) + 1

        const filename = dataDemoTrackvision[vehicleId][ch - 1]

        const urlDemo =
          process.env.VUE_APP_DEMO_ASSET_NUM_URL.replace('{number}', flagDomain) +
          '/' +
          vehicleId +
          '/' +
          filename

        newPlaylist.push({
          id: row.value,
          vehicleId,
          channel,
          camera: statusText.split(',').findIndex((x) => x == channel) + 1,
          licensePlate,
          calculatedMotionStatus,
          imei,
          driver,
          deviceType,
          uid: row.uid,
          streamingEndpoint,
          src: urlDemo,
          deviceCode,
        })
      })

      const allPlaylist = [...prevPlaylist, ...newPlaylist]
      commit('setPlaylistVehicle', allPlaylist)
      return { isDemo: isVideoDemo }
    }

    return { isDemo: isVideoDemo }
  },

  async requestOnlineCommandStreamStatus(_, payload) {
    try {
      const response = await client.mutate({
        mutation: SET_VIDEO_STREAM_STATUS,
        variables: {
          input: {
            ...payload,
          },
        },
      })
      return response
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  },

  async setVideoStreamStatusOff() {
    await client.mutate({
      mutation: SET_VIDEO_STREAM_STATUS_OFF,
    })
  },
}

export const mutations = {
  ORDER_BY(state, payload) {
    if (payload.objName == 'licensePlate') {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort((a, b) =>
          a.vehicle[payload.objName] > b.vehicle[payload.objName]
            ? 1
            : b.vehicle[payload.objName] > a.vehicle[payload.objName]
            ? -1
            : 0
        )
      } else {
        state.fleets = state.fleets.sort((a, b) =>
          b.vehicle[payload.objName] > a.vehicle[payload.objName]
            ? 1
            : a.vehicle[payload.objName] > b.vehicle[payload.objName]
            ? -1
            : 0
        )
      }
    } else {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort((a, b) =>
          a[payload.objName] > b[payload.objName]
            ? 1
            : b[payload.objName] > a[payload.objName]
            ? -1
            : 0
        )
      } else {
        state.fleets = state.fleets.sort((a, b) =>
          b[payload.objName] > a[payload.objName]
            ? 1
            : a[payload.objName] > b[payload.objName]
            ? -1
            : 0
        )
      }
    }
  },
  setFleets(state, payload) {
    state.fleets = payload
  },
  setVehicleStatuses(state, payload) {
    state.vehicleStatuses = payload
  },
  setTempVehicleStatusesByVehicleId(state, { vehicleId, data }) {
    state.tempVehicleStatuses[vehicleId] = data
  },
  setVehicleStatusesByVehicleId(state, { vehicleId, data }) {
    state.vehicleStatuses[vehicleId] = data
  },
  resetTempVehicleStatuses(state) {
    state.tempVehicleStatuses = {}
  },
  loadingFleets(state, payload) {
    state.loadingFleets = payload
  },

  setGridNumber(state, payload) {
    state.gridNumber = payload
  },

  setPlaylist(state, { dataVehicle, usingWsFlv }) {
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    const isVideoDemo = Object.keys(dataDemoTrackvision).includes(dataVehicle.vehicleId.toString())

    let tempPlaylist = [...state.playlist]

    const deviceType = Helper.methods.getDeviceType(dataVehicle.vehicle.device.deviceCode)

    const removeAll = tempPlaylist.filter((x) => x.vehicleId != dataVehicle.vehicleId)
    tempPlaylist = [...removeAll]

    const remain = dataVehicle.playlist.length + tempPlaylist.length - state.maxVideo
    if (remain) tempPlaylist.slice(remain)
    else tempPlaylist.slice(dataVehicle.playlist.length)

    const isHlsTesting = JSON.parse(
      store.state.identity.featureFlag.find((feature) => feature.key == 'is_hls_testing').value
    )

    const handleVideoDemo = () => {
      // handle video demo
      const isJc = dataVehicle.vehicle.device.deviceName.includes('JC')
      const cameraList = dataVehicle.playlist.map((data) =>
        isJc ? parseInt(data.split(':')[1]) + 1 : parseInt(data.split(':')[1])
      )

      const promises = []
      cameraList.forEach((camera) => {
        const filename = dataDemoTrackvision[dataVehicle.vehicleId][camera - 1]
        promises.push(
          client.query({
            query: GET_SIGNED_URL,
            variables: {
              filter: {
                filename,
                identifier: isJc ? 'jcDemo' : 'bsjDemo',
                vehicleId: dataVehicle.vehicleId,
              },
            },
            fetchPolicy: 'no-cache',
          })
        )
      })
      Promise.all(promises).then((response) => {
        dataVehicle.playlist.forEach((row, index) => {
          if (row != tempPlaylist[index]?.id) {
            const arr = row.split(':')
            const camera = dataVehicle.channel.findIndex((x) => x.value == row)
            tempPlaylist.push({
              id: row,
              vehicleId: arr[0],
              channel: arr[1],
              camera: camera + 1,
              licensePlate: dataVehicle.parent
                ? dataVehicle.parent?.vehicle.licensePlate
                : dataVehicle.vehicle.licensePlate,
              calculatedMotionStatus: dataVehicle.calculatedMotionStatus,
              imei: dataVehicle.vehicle.imei,
              driver: dataVehicle.vehicle.driver1?.fullname,
              src: response[index].data.getSignedUrl.getSignedUrl.url,
              deviceType,
              deviceCode: dataVehicle.vehicle.device.deviceCode,
            })
          } else {
            tempPlaylist[index] = null
          }
        })
        state.playlist = [...tempPlaylist]
      })
      return
    }

    if (isVideoDemo) {
      return handleVideoDemo()
    }

    dataVehicle.playlist.forEach((row, index) => {
      if (row != tempPlaylist[index]?.id) {
        const arr = row.split(':')
        const camera = dataVehicle.channel.findIndex((x) => x.value == row)
        tempPlaylist.push({
          id: row,
          vehicleId: arr[0],
          channel: arr[1],
          camera: camera + 1,
          licensePlate: dataVehicle.parent
            ? dataVehicle.parent?.vehicle.licensePlate
            : dataVehicle.vehicle.licensePlate,
          calculatedMotionStatus: dataVehicle.calculatedMotionStatus,
          streamingEndpoint: dataVehicle.streamingEndpoint,
          imei: dataVehicle.vehicle.imei,
          deviceType,
          uid: dataVehicle.playlistWithUid.find((data) => data.playlist === row).uid,
          driver: dataVehicle.parent
            ? dataVehicle.parent?.vehicle?.driver1?.fullname
            : dataVehicle.vehicle?.driver1?.fullname,
          deviceCode: dataVehicle.vehicle.device.deviceCode,

          usingWsFlv,
        })
      } else {
        tempPlaylist[index] = null
      }
    })

    tempPlaylist = tempPlaylist.map((data, index) => {
      const arr = data.id.split(':')
      const domain = (index % 5) + 1
      const fleet = state.fleets.find((fleet) => fleet.vehicleId == data.vehicleId)
      const imei = fleet?.vehicle.imei
      const _isVideoDemo = Object.keys(dataDemoTrackvision).includes(data.vehicleId)
      return {
        ...data,
        src: _isVideoDemo
          ? data.src
          : Helper.methods.getStreamingUrl(
              dataVehicle.vehicle.device.deviceCode,
              imei,
              arr[1],
              domain,
              data.streamingEndpoint,
              isHlsTesting,
              usingWsFlv
            ),
      }
    })

    state.playlist = [...tempPlaylist]
  },

  resetPlaylist(state) {
    state.playlist = []
  },

  removePlaylist(state, id) {
    state.playlist = state.playlist.filter((data) => data.id !== id)
  },

  setFleetListDisplay(state, payload) {
    state.fleetListDisplay = payload
  },

  setLastClosedPlaylist(state, payload) {
    state.lastClosedPlaylist = payload
  },

  setWorkerTrackvision(state, payload) {
    state.workerTrackvision = payload
  },

  setRecordIdActive(state, payload) {
    state.recordIdActive = payload
  },

  resetRecordIdActive(state) {
    state.recordIdActive = null
  },

  setVehicleTypeList(state, payload) {
    state.vehicleTypeList = payload
  },

  setVgroupsList(state, payload) {
    state.vgroupsList = payload
  },

  /**
   *
   * @param {string} playlistId format `{vehicleId}:{channel}`
   * @param {string} url url for flespi howen
   */
  addMapFlespiHowenState(state, { playlistId, url }) {
    state.mapFlespiHowenState = [...state.mapFlespiHowenState, { playlistId, url }]
  },

  setPlaylistVehicle(state, payload) {
    state.playlist = [...payload]
  },
}
